import {NavDropdown} from "react-bootstrap";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchProject} from "./../actions/ProjectAction";

function ProjectListNavDropdown() {

    const projects = useSelector(state => state.projectReducer.projectsList);
    const selectedId = useSelector(state => state.projectReducer.projectId);
    const currentProject = selectedId === "" ? "Select Project" : projects.filter(project => project.projectId === selectedId).map(project => project.projectName)[0];
    const dispatch = useDispatch();

    return (
        <NavDropdown title={currentProject} id="basic-nav-dropdown">
            {projects.map(project => <NavDropdown.Item key={project.projectId}
                                                       href={"#" + project.projectId}
                                                       onClick={() => dispatch(fetchProject(project.projectId))}>{project.projectName}</NavDropdown.Item>)}
        </NavDropdown>
    )
}

export default ProjectListNavDropdown